import { Box, BoxProps, Flex, Stack } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';

import { routes } from '@blockpulse3/data/shared';
import { BrandIcon } from '@blockpulse3/ui/brand-theme';
import { useBreakpoints } from '@blockpulse3/ui/ui-hooks';

import { SettingsMenu } from '../../SettingsMenu';
import { SettingsNav } from '../../SettingsNav';
import { SettingsNotifications } from '../../SettingsNotifications';
import { SwitcherButton } from '../../SwitcherModal';

type Props = BoxProps;

export function SidebarDesktop({ ...props }: Props): JSX.Element {
  const location = useLocation();

  const { isDesktop, isLargeScreen } = useBreakpoints();

  const isDraft: boolean = location.pathname?.includes('/new-workspace/spv');
  const isManaging: boolean = location.pathname?.includes('/manage');

  return (
    <Flex
      bg={props.bg || 'primary'}
      color="white"
      direction="column"
      flexShrink="0"
      height="calc(var(--vh, 1vh) * 100)"
      overflowY="auto"
      position="fixed"
      top="0"
      w="64"
      zIndex="2"
      {...props}
    >
      <Stack p="3" pt="6" spacing="8">
        {isDesktop || isLargeScreen ? (
          <Link to={isManaging ? routes.admin.href : routes.home.href}>
            <Stack h="55px" justifyContent="center" w="full">
              <BrandIcon bgTheme="dark" h="full" maxW="200px" w="full" />
            </Stack>
          </Link>
        ) : null}
        {!isManaging && <SwitcherButton />}
      </Stack>
      <Stack flex="1" flexShrink="0" justifyContent="flex-start" p="3" spacing="8">
        {!isDraft && <SettingsNav />}
      </Stack>
      <Stack spacing="2">
        <Box px="3">
          <SettingsNotifications />
        </Box>
        <Box pb="3" px="3">
          <SettingsMenu />
        </Box>
      </Stack>
    </Flex>
  );
}

export type SidebarDesktopProps = Props;
